import request from './request'
// 首页-banner
export function getBanner(params) {
    return request('lb/index')
}
// 首页-介绍（4个参数的介绍信息）
export function getAction(params) {
    return request('zl/index')
}
// 首页-介绍配图
export function getPt(params={id:1}) {
    return request('pt/index',params)
}
// 走进佳驰-公司简介
export function gsjj(params={id:1}) {
    return request('gsjj/view',params)
}
// 走进佳驰-发展历程
export function lc(params={limit:7}) {
    return request('lc/index',params)
}
// 走进佳驰-合作伙伴
export function hzhb(params) {
    return request('hzhb/index',params)
}
// 服务能力
export function fw() {
    return request('fw/index')
}
// 服务能力-详情页
export function fw_view(params) {
    return request('fw/view',params)
}
// 产品中心-产品列表
export function productList(params) {
    return request('product/index',params)
}
// 产品中心-产品列表
export function productview(params) {
    return request('product/view',params)
}
// 产品中心-分类名称
export function classe(params) {
    return request('classe/index',params)
}
// 新闻中心
export function article(params) {
    return request('article/index',params)
}
// 新闻中心-详情页
export function article_view(params) {
    return request('article/view',params)
}
// 联系我们
export function pz(params={id:1}) {
    return request('pz/view',params)
}
// 加入我们-人才理念
export function rc() {
    return request('rc/index')
}
// 加入我们-招贤纳士
export function zp(params) {
    return request('zp/index',params)
}
// 招聘报名
export function bm(params) {
    return request('bm/add',params)
}